import GridOnRoundedIcon from '@mui/icons-material/GridOnRounded';
import PictureAsPdfRoundedIcon from '@mui/icons-material/PictureAsPdfRounded';
import Box from '@mui/material/Box';

export type DropdownOptionBadgePreset = 'excel' | 'pdf';

const FORMAT_STYLES = {
  excel: {
    color: '#477500',
    backgroundColor: '#EEF7E0',
    borderColor: '#B8D889',
    shadowColor: 'rgba(71, 117, 0, 0.14)',
  },
  pdf: {
    color: '#B42318',
    backgroundColor: '#FFF0EE',
    borderColor: '#F4B8B2',
    shadowColor: 'rgba(180, 35, 24, 0.13)',
  },
} as const satisfies Record<
  DropdownOptionBadgePreset,
  { color: string; backgroundColor: string; borderColor: string; shadowColor: string }
>;

type Props = {
  format: DropdownOptionBadgePreset;
};

export function FileFormatBadge({ format }: Props) {
  const styles = FORMAT_STYLES[format];
  const FormatIcon = format === 'excel' ? GridOnRoundedIcon : PictureAsPdfRoundedIcon;

  return (
    <Box
      component="span"
      className="SiloReal-Dropdown-FileFormatBadge"
      aria-label={`Formato ${format.toUpperCase()}`}
      sx={{
        display: 'inline-flex',
        height: 24,
        flexShrink: 0,
        alignItems: 'center',
        gap: 0.5,
        pl: 0.375,
        pr: 0.75,
        border: '1px solid',
        borderRadius: '6px',
        color: styles.color,
        backgroundColor: styles.backgroundColor,
        borderColor: styles.borderColor,
        boxShadow: `inset 0 1px 0 rgba(255, 255, 255, 0.72), 0 2px 5px ${styles.shadowColor}`,
        fontSize: 9.5,
        fontWeight: 800,
        lineHeight: 1,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
      }}
    >
      <Box
        component="span"
        aria-hidden
        sx={{
          width: 17,
          height: 17,
          display: 'grid',
          flex: '0 0 17px',
          placeItems: 'center',
          borderRadius: '4px',
          color: '#FFFFFF',
          backgroundColor: styles.color,
          boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.22)',
        }}
      >
        <FormatIcon sx={{ fontSize: 12 }} />
      </Box>
      <Box component="span">{format}</Box>
    </Box>
  );
}
